<div class="integracao-log-dialog__overlay" (click)="onFechar()">
  <div
    class="integracao-log-dialog"
    role="dialog"
    aria-modal="true"
    aria-labelledby="integracao-log-dialog-title"
    data-testid="integracao-log-dialog"
    (click)="$event.stopPropagation()"
  >
    <h2 id="integracao-log-dialog-title" class="integracao-log-dialog__title">
      Log de integração
    </h2>

    @if (log().execucoes.length === 0) {
      <p class="integracao-log-dialog__vazio" data-testid="log-sem-execucao">
        Nenhuma integração foi executada nesta carga.
      </p>
    } @else {
      <div class="integracao-log-dialog__execucoes">
        @for (execucao of log().execucoes; track $index) {
          <section class="integracao-log-dialog__execucao" data-testid="log-execucao">
            <header class="integracao-log-dialog__cabecalho">
              <div class="integracao-log-dialog__identificacao">
                <span class="integracao-log-dialog__data" data-testid="log-execucao-data-inicio">
                  {{ execucao.dataInicio }}
                </span>
                <span class="integracao-log-dialog__autoria">
                  Por
                  <strong data-testid="log-execucao-usuario">{{ execucao.usuario }}</strong>
                  ·
                  <span data-testid="log-execucao-qtd">{{ execucao.qtdRegistros }}</span>
                  {{ execucao.qtdRegistros === 1 ? 'registro selecionado' : 'registros selecionados' }}
                </span>
              </div>

              <span
                [class]="'integracao-log-dialog__situacao integracao-log-dialog__situacao--' + execucao.status"
                data-testid="log-execucao-status"
              >{{ rotuloStatus(execucao.status) }}</span>
            </header>

            <dl class="integracao-log-dialog__resumo">
              <div class="integracao-log-dialog__celula">
                <dt>Selecionados</dt>
                <dd data-testid="log-execucao-total">{{ execucao.resumo.total }}</dd>
              </div>
              <div
                class="integracao-log-dialog__celula integracao-log-dialog__celula--integrados"
              >
                <dt>Integrados</dt>
                <dd data-testid="log-execucao-integrados">{{ execucao.resumo.integrados }}</dd>
              </div>
              <div class="integracao-log-dialog__celula integracao-log-dialog__celula--erro">
                <dt>Erro de sistema</dt>
                <dd data-testid="log-execucao-erro-sistema">{{ execucao.resumo.erroSistema }}</dd>
              </div>
              <div class="integracao-log-dialog__celula integracao-log-dialog__celula--erro">
                <dt>Erro na integração</dt>
                <dd data-testid="log-execucao-erro-integracao">
                  {{ execucao.resumo.erroIntegracao }}
                </dd>
              </div>
            </dl>
          </section>
        }
      </div>
    }

    <div class="integracao-log-dialog__actions">
      <button
        type="button"
        class="btn-primary btn-toolbar"
        data-testid="integracao-log-dialog-fechar"
        (click)="onFechar()"
      >
        Fechar
      </button>
    </div>
  </div>
</div>
